// extracted by mini-css-extract-plugin
export default {"announcement":"styles_announcement__o-wSE","inner":"styles_inner__q8Oso","text":"styles_text__uxDds"};